/* ==========================================================================
   TechNest — faq.js
   Client-side filtering of the questions already on the page. No network
   request and no search index: the searchable text is rendered into a data
   attribute by Liquid. With JavaScript off the questions remain a plain,
   fully usable list of accordions.
   ========================================================================== */
(function () {
  'use strict';

  const TN = window.TechNest || {};
  const utils = TN.utils;
  if (!utils) return;

  class TnFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-tn-faq-item]'));
      this.emptyState = this.querySelector('[data-tn-faq-empty]');
      this.status = this.querySelector('[data-tn-faq-status]');
      this.searchInput = this.querySelector('[data-tn-faq-search]');
      this.filters = Array.from(this.querySelectorAll('[data-tn-faq-filter]'));
      this.category = 'all';
      this.term = '';

      if (this.searchInput) {
        this.searchInput.addEventListener(
          'input',
          utils.debounce(() => {
            this.term = this.searchInput.value.trim().toLowerCase();
            this.apply();
          }, 200)
        );
      }

      this.filters.forEach((button) => {
        button.addEventListener('click', () => {
          this.category = button.dataset.tnFaqFilter;
          this.filters.forEach((b) => {
            const active = b === button;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', String(active));
          });
          this.apply();
        });
      });
    }

    apply() {
      let visible = 0;

      this.items.forEach((item) => {
        const matchesCategory = this.category === 'all' || item.dataset.category === this.category;
        const matchesTerm = !this.term || (item.dataset.text || '').indexOf(this.term) > -1;
        const show = matchesCategory && matchesTerm;
        item.hidden = !show;
        if (show) {
          visible += 1;
          // Auto-open matches while searching so the answer is visible.
          if (this.term) item.open = true;
        } else {
          item.open = false;
        }
      });

      if (this.emptyState) this.emptyState.hidden = visible > 0;

      if (this.status) {
        this.status.textContent = visible
          ? utils.format(TN.strings.faqCount || '', { count: visible })
          : '';
      }
    }
  }

  utils.define('tn-faq', TnFaq);
})();
